var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.$style.infoPanel,
    _vm.$style[_vm.theme],
    ( _obj = {}, _obj[_vm.$style.hasNoIcon] = _vm.hasNoIcon, _obj[_vm.$style.small] = _vm.hasSmallPaddingVertical, _obj[_vm.$style.darkColor] = _vm.hasDarkTextColor, _obj ) ]},[(!_vm.hasNoIcon)?_c(_vm.iconComponent,{tag:"component",class:_vm.$style.icon}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }